/**
 * 解析器/解析脚本的客户端静态校验（纯函数，便于单测）
 * - validateParserText：数据集解析器 JSON（path/mapping/filter/transform）
 * - validateParseScriptClient：设备解析脚本 JS（语法 + 是否定义 parse）
 */

export function validateParserText(text: string): string {
  let obj: any;
  try {
    obj = JSON.parse(text || '{}');
  } catch (e: any) {
    return `JSON 语法错误：${e?.message || e}`;
  }
  if (obj == null || typeof obj !== 'object' || Array.isArray(obj)) return '解析器必须是 JSON 对象';
  if (obj.mapping !== undefined && !Array.isArray(obj.mapping)) return 'mapping 必须是数组';
  if (obj.transform) {
    try {
      // eslint-disable-next-line no-new-func
      new Function('data', `return (${obj.transform});`);
    } catch (e: any) {
      return `transform JS 语法错误：${e?.message || e}`;
    }
  }
  if (obj.filter) {
    try {
      // eslint-disable-next-line no-new-func
      new Function('item', 'index', 'data', `return (${obj.filter});`);
    } catch (e: any) {
      return `filter 表达式语法错误：${e?.message || e}`;
    }
  }
  return '';
}

export function validateParseScriptClient(script: string): string {
  if (!script || !script.trim()) return '脚本为空';
  if (script.length > 200 * 1024) return '脚本超过 200KB 限制';
  try {
    // eslint-disable-next-line no-new-func
    new Function(script);
  } catch (e: any) {
    return `语法错误：${e?.message || e}`;
  }
  if (!/\bparse\s*[=(]/.test(script)) return '脚本需定义 parse(payload, meta) 函数';
  return '';
}
